import { ACTION_FORMATS } from './custom-types'

export type TActionIconColorsStyles = {
  format: ACTION_FORMATS
  value: string
}

export const ActionIconsColors: TActionIconColorsStyles[] = [
  { format: ACTION_FORMATS.info, value: 'RichTextEditor__action--info' },
  { format: ACTION_FORMATS.warning, value: 'RichTextEditor__action--warning' },
  { format: ACTION_FORMATS.tip, value: 'RichTextEditor__action--tip' },
]
